import type { EarnPolicySetting } from '@/utils/earnPolicy'

/**
 * lookup `settings`에서 항목 탐색.
 * 최상위 키 또는 DEFAULT / PROJECT 등 그룹 객체 안의 키를 찾는다.
 */
export function findProjectSetting(
  settings: Record<string, unknown> | undefined,
  key: string
): unknown {
  if (!settings) return undefined

  const direct = settings[key]
  if (direct != null) return direct

  for (const value of Object.values(settings)) {
    if (value == null || typeof value !== 'object' || Array.isArray(value)) continue
    const nested = (value as Record<string, unknown>)[key]
    if (nested != null) return nested
  }

  return undefined
}

/** settings 항목이 mashup ENUM_SINGLE 형태일 때 value 추출 */
export function readEnumSingleSettingValue(setting: unknown): string | undefined {
  if (setting == null) return undefined
  if (typeof setting === 'string') {
    const trimmed = setting.trim()
    return trimmed || undefined
  }
  if (typeof setting !== 'object') return undefined

  const item = setting as Partial<EarnPolicySetting>
  if (item.type !== 'ENUM_SINGLE') return undefined
  const value = String(item.value ?? '').trim()
  return value || undefined
}
